import { useState, useEffect, useRef, useCallback } from "react";
import "./homepage.css";
// import Avatar from '../Images/marine_4.png'
// import Avatar1 from '../Images/new_m_2.png'
// import Avatar3 from '../Images/new_m_4.png'
import Avatar4 from '../Images/new_pic_4.png'
// import Avatar5 from '../Images/new_pic_5.png'
import Footer from '../Component/NewFooter'
import Logo1 from '../Images/partners/prt1.png'
import Logo2 from '../Images/partners/prt2.png'
import Logo3 from '../Images/partners/prt3.png'
import Logo4 from '../Images/partners/prt4.png'
import Logo5 from '../Images/partners/prt5.png'
import Logo6 from '../Images/partners/prt6.png'
import Logo7 from '../Images/partners/prt7.png'
import Logo8 from '../Images/partners/prt8.png'
import Logo9 from '../Images/partners/prt9.png'
import Logo10 from '../Images/partners/prt10.png'
import Logo11 from '../Images/partners/prt11.png'
import Logo12 from '../Images/partners/seplat.png'
// import Logo13 from '../Images/partners/prt13.png'
import Slide1 from '../Images/new_pic_1.png'
import Slide2 from '../Images/s2.png'
import Slide3 from '../Images/new_pic_2.png'
import Slide4 from '../Images/s4.png'
import Slide5 from '../Images/new_pic_3.jpeg'
import Slide6 from '../Images/s6.jpeg'
import Aboutbg from '../Images/jeysh.jpeg'


import {
  FaWrench,
  FaBoxOpen,
  FaHardHat,
  FaClipboardCheck,
  FaSatelliteDish,
  FaShip,
} from "react-icons/fa";    

/* ─── Data ─── */
const heroSlides = [
  {
    bg: Slide1,
    title: "Driven by Innovation. Built on Integrity.",
  },
  {
    bg: Slide2,
    title: "Empowering Communities Through Energy.",
  },
  {
    bg: Slide3,
    title: "Integrated Energy Services, Proven Results. ",
  },
  {
    bg: Slide4,
    title: "Local Strength. Global Standards.",
  },
  {
    bg: Slide5,
    title: "Engineering Energy for Sustainable Growth.",
  },
  {
    bg: Slide6,
    title: "Excellence in Oil, Gas & Energy Services.",
  },
];

const services = [
  {
    icon: <FaWrench />,
    title: "Engineering",
    desc: "We bring together experienced engineers, project managers, and technical experts who are passionate about solving complex engineering challenges and delivering long-lasting solutions.",
    href: "/engineering",
  },
  {
    icon: <FaBoxOpen />,
    title: "Procurement",
    desc: "Our Procurement Services are designed to ensure timely, cost-efficient, and quality-assured sourcing of materials, equipment, and services essential for project success.",
    href: "/procurement",
  },
  {
    icon: <FaHardHat />,
    title: "Construction",
    desc: "We deliver high-quality, safe, and efficient solutions across a wide range of sectors, including oil & gas, infrastructure, energy, and industrial facilities.",
    href: "/construction",
  },
  {
    icon: <FaClipboardCheck />,
    title: "Commissioning",
    desc: "Comprehensive commissioning services ensuring all systems and equipment are tested, verified, and fully operational before handover, meeting all technical specifications.",
    href: "/commissioning",
  },
  {
    icon: <FaSatelliteDish />,
    title: "Installation and Instrumentation",
    desc: "Expert installation services for complex equipment and systems, ensuring precise execution, safety compliance, and seamless integration with existing infrastructure.",
    href: "/installation",
  },
  {
    icon: <FaShip />,
    title: "Marine Support",
    desc: "Specialized marine support services providing offshore logistics, vessel operations, and maritime technical solutions for oil & gas operations in challenging environments.",
    href: "/marine-support",
  },
];

// const values = [
//   "Professionalism", "Accountability",
//   "Excellence", "Leadership",
//   "Integrity", "Teamwork",
//   "Empowerment",
// ];

const clients = [
  { name: "AGIP", logo: Logo1 },
  { name: "Chevron", logo: Logo2 },
  { name: "Shell", logo: Logo3 },
  { name: "LNG Nigeria", logo: Logo4 },
  { name: "TotalEnergies", logo: Logo5 },
  { name: "Lee Engineering", logo: Logo6 },
  { name: "ExxonMobil", logo: Logo12 },
  { name: "NNPC", logo: Logo7 },
  { name: "ExxonMobil", logo: Logo8 },
  { name: "ExxonMobil", logo: Logo9 },
  { name: "ExxonMobil", logo: Logo10 },
  { name: "ExxonMobil", logo: Logo11 },
  // { name: "ExxonMobil", logo: Logo13 },
];

function ServiceCard({ icon, title, desc, href }) {
  return (
    <div className="service-card">
      <div className="service-card__icon">{icon}</div>
      <h3>{title}</h3>
      <p>{desc}</p>
      <a href={href} className="btn btn--navy">Learn More</a>
    </div>
  );
}

const Homepage = () => {
  const [current, setCurrent] = useState(0);
  // Add this state at the top of your component (with the other useState hooks)
const [videoOpen, setVideoOpen] = useState(false);

  const go = (n) => setCurrent((n + heroSlides.length) % heroSlides.length);

  useEffect(() => {
    const timer = setInterval(
      () => setCurrent((c) => (c + 1) % heroSlides.length),
      8500
    );
    return () => clearInterval(timer);
  }, []);

  const slide = heroSlides[current];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const intervalRef = useRef(null);
  const itemsPerView = 6;

  // Number of full sets (pages)
  const totalSets = Math.ceil(clients.length / itemsPerView);
  const maxIndex = totalSets - 1;

  // Move forward by one full set
  const nextSlide = useCallback(() => {
    setCurrentIndex(p => (p >= maxIndex ? 0 : p + 1));
  }, [maxIndex]);

  // Move backward by one full set
  const prevSlide = useCallback(() => {
    setCurrentIndex(p => (p <= 0 ? maxIndex : p - 1));
  }, [maxIndex]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    if (isAutoPlaying) {
      intervalRef.current = setInterval(nextSlide, 4000);
    }
    return () => clearInterval(intervalRef.current);
  }, [isAutoPlaying, nextSlide]);

  return (
    <>
      <section className="hero" id="home">
        <div
          className="hero__bg"
          style={{ backgroundImage: `url(${slide.bg})` }}
        />

        <div className="hero__content">
          <h1>{slide.title}</h1>
          <p>{slide.sub}</p>
          <a href="#about" className="btn btn--orange">Read More</a>
        </div>

        <button
          className="hero__arrow hero__arrow--prev"
          onClick={() => go(current - 1)}
          aria-label="Previous slide"
        >
          &#8249;
        </button>
        <button
          className="hero__arrow hero__arrow--next"
          onClick={() => go(current + 1)}
          aria-label="Next slide"
        >
          &#8250;
        </button>

        <div className="hero__dots">
          {heroSlides.map((_, i) => (
            <button
              key={i}
              onClick={() => go(i)}
              className={`hero__dot${i === current ? " hero__dot--active" : ""}`}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>
      </section>

      <div className="announcement">
        <div className="announcement_carrier">
          <p>The reference point for true local content development in the oil &amp; gas industry</p>
          <a href="#about" className="btn btn--dark">Read More</a>
        </div>
      </div>

      <section className="section light_green" id="about"  style={{backgroundImage: `url(${Aboutbg})`, backgroundSize: "cover", backgroundPosition: "center"}}>
        <div className="welcome__grid">
          <div className="welcome__text">
            <h2>We provide end-to-end project execution services</h2>
            <p>
               <span style={{fontWeight: "bolder", textTransform: 'uppercase'}}>Jeyshawn Engineering Limited</span> was incorporated in 2012 with the CAC, Federal Republic of Nigeria with RC Number: 1026776. Jeyshawn Engineering Limited is a recognized indigenous EPCIC leader, delivering world-class engineering and project execution services across the oil & gas and energy sectors. Jeyshawn is known for safety, excellence, technical competence, strong governance and sustainable growth.
            </p>
            <p>
              With a track record of excellence, safety and innovations, Jeyshawn Engineering Limited provides end-to-end project execution services, ensuring timely delivery and operational efficiency for complex industrial projects.
            </p>
            <p>
              Our multi-disciplinary team of professionals brings deep industry expertise and technical know-how to deliver value-driven solutions that meets global standards.
            </p>
              <section class="stats-wrap">
    <div class="stat-block">
      <div class="stat-number">105,120</div>
      <div class="stat-label">Man Hours With Zero Fatality</div>
    </div>
 
    <div class="divider" aria-hidden="true"></div>
 
    <div class="stat-block">
      <div class="stat-number">23 <span class="accent">PROJECTS</span></div>
      <div class="stat-label">With 100% Completion Rate</div>
    </div>
  </section>
          </div>
          
          <div className="welcome__images">
  <img src={Avatar4} alt="Oilfield worker" />
  <button className="play-btn" onClick={() => setVideoOpen(true)}>
    <span className="play-btn__icon">
      <svg viewBox="0 0 10 12" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 0 L10 6 L0 12 Z" />
      </svg>
    </span>
  </button>
</div>

{videoOpen && (
  <div
    className="video-modal-overlay"
    onClick={(e) => e.target === e.currentTarget && setVideoOpen(false)}
  >
    <div className="video-modal">
      <button className="video-modal__close" onClick={() => setVideoOpen(false)}>✕</button>
  
      
      <iframe
  src="https://www.youtube.com/embed/0dukIHOb5f4?autoplay=1"
  allow="autoplay; encrypted-media; fullscreen"
  allowFullScreen
  title="Company Video"
/>
    </div>
  </div>
)}

        </div>
      </section>

      <section className="section section--light" id="services">
        <h2 className="section__title">What We Do</h2>
        <div className="services__grid">
          {services.map((s, i) => (
            <ServiceCard key={i} {...s} />
          ))}
        </div>
      </section>

      <section className="section section--navy" id="values">
        {/* <div className="values__grid-outer">
          <div className="values__image">
            <img src={Avatar5} alt="Core Values" />
          </div> */}
          {/* <div className="values__content">
            <h2>Our Values</h2>
            <p>
              Our core values support the company's vision and shape its culture.
              They are the principles which guide the way we deliver value to our
              customers and grow the exceptional capabilities of our people.
            </p>
            <div className="values__inner-grid">
              {values.map((v, i) => (
                <div key={i} className="value-item">
                  <div className="value-item__icon">★</div>
                  <span>{v}</span>
                </div>
              ))}
            </div>
          </div> */}
        {/* </div> */}

          <div class="cv-section">
    <div class="cv-label">Core Values</div>
    <div class="cv-grid">
 
      <div class="cv-item">
        <div class="cv-name">Professionalism</div>
        <div class="cv-desc">At Jeyshawn Engineering Limited, professionalism defines how we operate and interact with our clients, partners, and host communities. We uphold the highest standards of competence, discipline, respect, and ethical conduct in every aspect of our operations. 
</div>
      </div>
 
      <div class="cv-item">
        <div class="cv-name">Accountability</div>
        <div class="cv-desc">We take full ownership of our responsibilities, commitments, and project outcomes. Accountability is at the heart of our operations, driving us to deliver on our promises with transparency, reliability, and consistency. </div>
      </div>
 
      <div class="cv-item">
        <div class="cv-name">Excellence</div>
        <div class="cv-desc">We are committed to achieving excellence in everything we do. Through continuous improvement, innovation, and adherence to global industry standards and best practices, we consistently deliver high-quality engineering solutions that exceed clients’ expectations.</div>
      </div>
 
      <div class="cv-item">
        <div class="cv-name">Leadership</div>
        <div class="cv-desc">We lead with vision and purpose. Our leadership culture inspires teamwork, innovation, and boost employees' confidence while empowering our workforce to achieve outstanding results. </div>
      </div>
 
      <div class="cv-item">
        <div class="cv-name">Integrity</div>
        <div class="cv-desc">Integrity is the foundation of our business. We conduct all operations with honesty, fairness, transparency, and ethical responsibility, building trust through responsible actions, open communication, and unwavering professional standards.</div>
      </div>
 
      <div class="cv-item">
        <div class="cv-name">Teamwork</div>
        <div class="cv-desc">We believe collaboration is essential for organisational success. Our strength lies in the ability of our team to work together across different disciplines, combining skills, experience, and ideas to achieve shared goals. Through mutual respect, trust, and cooperation, we deliver innovative solutions and successful project outcomes for our clients.</div>
      </div>
 
      <div class="cv-item">
        <div class="cv-name">Empowerment</div>
        <div class="cv-desc">We are dedicated to empowering our people and our host community by creating an environment that encourages growth, creativity, innovation, and continuous learning. </div>
      </div>
 
    </div>
  </div>
      </section>

      <section
        className="clients-section"
        onMouseEnter={() => setIsAutoPlaying(false)}
        onMouseLeave={() => setIsAutoPlaying(true)}
      >
        <h2 className="clients__title">Our Clients</h2>
        <p className="clients__subtitle">
          At Jeyshawn Engineering Limited, we build lasting partnerships based on trust, integrity and performance. Our clients rely on us for innovative engineering solutions executed with a strong commitment to safety, quality and excellence. Together, we deliver projects that drive operational success and sustainable value.
        </p>

        <div className="clients__carousel">
          <button className="clients__arrow clients__arrow--prev" onClick={prevSlide}>
            ‹
          </button>

          <div className="clients__viewport">
            <div
              className="clients__track"
              style={{
                transform: `translateX(-${currentIndex * 100}%)`,
              }}
            >
              {clients.map((client, i) => (
                <div key={i} className="clients__card">
                  <img src={client.logo} alt={client.name} className="clients__logo-img" />
                </div>
              ))}
            </div>
          </div>

          <button className="clients__arrow clients__arrow--next" onClick={nextSlide}>
            ›
          </button>
        </div>

        <div className="clients__dots">
          {Array.from({ length: totalSets }).map((_, i) => (
            <button
              key={i}
              className={`clients__dot ${i === currentIndex ? 'clients__dot--active' : ''}`}
              onClick={() => goToSlide(i)}
            />
          ))}
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Homepage;